import React from 'react'
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { useLocation, useNavigate } from 'react-router-dom'
import DualActionButtons from '../components/action_button/DualActionButtons'
import {
  UI_COLOR_ACCENT_ORANGE,
  UI_COLOR_BORDER_LIGHT,
  UI_COLOR_BUTTON_MUTED,
  UI_COLOR_PRIMARY,
  UI_COLOR_PRIMARY_HOVER,
  UI_COLOR_TEXT_HEADING,
  UI_COLOR_TEXT_SUBTITLE
} from '../constants/uiColors'
import { isSecurityConfigured } from './sessionCookies'

const MFA_SETUP_PATH = '/perfil/seguridad'
const MFA_HOME_PATH = '/inicio'

function isMfaSetupExemptPath(pathname) {
  return (
    pathname === MFA_HOME_PATH ||
    pathname === '/logout' ||
    pathname === '/activate-account' ||
    pathname === '/perfil' ||
    pathname.startsWith('/perfil/')
  )
}

export default function RequireMfaSetupGate() {
  const location = useLocation()
  const navigate = useNavigate()
  const mustSetupMfa = !isSecurityConfigured() && !isMfaSetupExemptPath(location.pathname)

  return (
    <Dialog
      open={mustSetupMfa}
      disableEscapeKeyDown
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '16px',
          border: `1px solid ${UI_COLOR_BORDER_LIGHT}`,
          overflow: 'hidden'
        }
      }}
    >
      <DialogTitle sx={{ px: 2.5, pt: 2.5, pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: '12px',
              display: 'grid',
              placeItems: 'center',
              bgcolor: '#FFF4E5',
              color: UI_COLOR_ACCENT_ORANGE,
              flexShrink: 0
            }}
          >
            <ShieldOutlinedIcon sx={{ fontSize: 22 }} />
          </Box>
          <Typography sx={{ fontSize: 16, fontWeight: 800, color: UI_COLOR_TEXT_HEADING }}>
            Configura un método de verificación
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ px: 2.5, pb: 1.5 }}>
        <Typography sx={{ fontSize: 14, color: UI_COLOR_TEXT_SUBTITLE, lineHeight: 1.5 }}>
          Para usar los módulos de Torre de Control necesitas al menos un método de verificación. El
          principal es un código que llega a tu correo. Si ese correo no está verificado, pide a un
          administrador que lo corrija.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 2.5, pb: 2.5 }}>
        <DualActionButtons
          fullWidthOnMobile={false}
          minWidth={112}
          gap={1}
          secondaryAction={{
            label: 'Ir al inicio',
            icon: null,
            color: UI_COLOR_BUTTON_MUTED,
            hoverColor: UI_COLOR_BUTTON_MUTED,
            hoverBackgroundColor: '#FFFFFF',
            hoverTextColor: UI_COLOR_BUTTON_MUTED,
            sx: { fontWeight: 500 },
            onClick: () => navigate(MFA_HOME_PATH)
          }}
          primaryAction={{
            label: 'Ir a seguridad',
            icon: null,
            color: UI_COLOR_PRIMARY,
            hoverColor: UI_COLOR_PRIMARY_HOVER,
            sx: { fontWeight: 500 },
            onClick: () => navigate(MFA_SETUP_PATH)
          }}
        />
      </DialogActions>
    </Dialog>
  )
}
